var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBronzeBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 23.1245C2.25 24.1845 2.76344 25.1789 3.62771 25.7927L16.105 34.6542C17.2398 35.4601 18.7602 35.4601 19.895 34.6542L32.3723 25.7927C33.2366 25.1789 33.75 24.1845 33.75 23.1245V3.27273C33.75 1.46525 32.2847 9.53674e-07 30.4773 9.53674e-07H18H5.52273C3.71525 9.53674e-07 2.25 1.46525 2.25 3.27273V23.1245Z",
    fill: "#4B5563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22.3456C4.5 23.1258 4.87089 23.8595 5.49912 24.3221L16.5446 32.4556C17.4102 33.093 18.5898 33.093 19.4554 32.4556L30.5009 24.3221C31.1291 23.8595 31.5 23.1258 31.5 22.3456V4.70688C31.5 3.35127 30.4011 2.25234 29.0455 2.25234H18H6.95454C5.59894 2.25234 4.5 3.35128 4.5 4.70688V22.3456Z",
    fill: "#FB8B5A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6151_14375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 28,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22.3456C4.5 23.1258 4.87089 23.8595 5.49912 24.3221L16.5446 32.4556C17.4102 33.093 18.5898 33.093 19.4554 32.4556L30.5009 24.3221C31.1291 23.8595 31.5 23.1258 31.5 22.3456V4.70688C31.5 3.35127 30.4011 2.25234 29.0455 2.25234H18H6.95454C5.59894 2.25234 4.5 3.35128 4.5 4.70688V22.3456Z",
    fill: "#FB8B5A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6151_14375)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.3789,
    y: -12.1484,
    width: 5.02277,
    height: 44.2003,
    transform: "rotate(60 28.3789 -12.1484)",
    fill: "#FFD2BE"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30078 21.9651C6.30078 22.3479 6.47932 22.7087 6.78357 22.9408L17.2563 30.9319C17.6959 31.2674 18.3056 31.2674 18.7453 30.9319L29.218 22.9408C29.5222 22.7087 29.7008 22.3479 29.7008 21.9651V5.27728C29.7008 4.59948 29.1513 4.05001 28.4735 4.05001H18.0008H7.52805C6.85025 4.05001 6.30078 4.59948 6.30078 5.27728V21.9651Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44922 13.5H26.5492L17.9992 23.85L9.44922 13.5Z",
    fill: "#FB8B5A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44922 13.5H15.2992L17.9992 23.85L9.44922 13.5Z",
    fill: "#FFD2BE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7 13.5H26.55L18 23.85L20.7 13.5Z",
    fill: "#E07647"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1492 9.89844H23.8492L26.5492 13.4984H9.44922L12.1492 9.89844Z",
    fill: "#FB8B5A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8492 9.89844L26.5492 13.4984H20.6992L23.8492 9.89844Z",
    fill: "#CA5C2D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1508 9.89844L9.45078 13.4984H15.3008L12.1508 9.89844Z",
    fill: "#E07647"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9992 9.89844L15.2992 13.4984H20.6992L17.9992 9.89844Z",
    fill: "#FFD2BE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0664 11.6953L20.9626 11.8787L21.647 11.2718L21.4636 12.168L22.0705 12.8524L21.1744 12.669L20.4899 13.2759L20.6733 12.3797L20.0664 11.6953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeBadge);
export default __webpack_public_path__ + "static/media/bronzeBadge.58049dd75547d1d13b85c75d139ce560.svg";
export { ForwardRef as ReactComponent };